import { useMemo } from "react"

import {
  UNASSIGNED_PRODUCTS_TAB_ID,
  UNASSIGNED_ROOMS_TAB_ID
} from "entities/project-children/lib/projectTabIDs"

import { ProjectPageTabBarProps } from "../ProjectPageTabBar"
import { ProjectPageTabBarViewModel } from "../ProjectPageTabBarView"

export function useProjectPageTabBarViewModel({
  projectID,
  floors,
  onSelect,
  activeTabID,
  unassignedRoomsCount,
  unassignedProductsCount,
  onSelectFloor,
  onDrop,
  ariaControls,
  truncationThreshold = 15,
  onFloorSort,
  FloorTabRenderer
}: ProjectPageTabBarProps): ProjectPageTabBarViewModel {
  const activeKey = useMemo(() => {
    if (activeTabID) return activeTabID

    if (unassignedRoomsCount > 0) return UNASSIGNED_ROOMS_TAB_ID
    if (unassignedProductsCount > 0) return UNASSIGNED_PRODUCTS_TAB_ID
    if (floors[0]) return floors[0].id

    return UNASSIGNED_ROOMS_TAB_ID
  }, [activeTabID, unassignedRoomsCount, unassignedProductsCount, floors])

  return {
    projectID,
    activeKey,
    activeTabID,
    onSelect,
    unassignedRoomsCount,
    unassignedProductsCount,
    floors,
    onSelectFloor,
    truncationThreshold,
    onDrop,
    ariaControls,
    onFloorSort,
    FloorTabRenderer
  }
}
